import { render, staticRenderFns } from "./ValidationSidebar.vue?vue&type=template&id=24563cb8&scoped=true"
import script from "./ValidationSidebar.vue?vue&type=script&lang=js"
export * from "./ValidationSidebar.vue?vue&type=script&lang=js"
import style0 from "./ValidationSidebar.vue?vue&type=style&index=0&id=24563cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24563cb8",
  null
  
)

export default component.exports